// src/redux/api/menuApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../api/api';
;

const ACCESS_TOKEN = 'Y7JiXi2azOF_-s_c4_3kq9O1pNNdCpZn';

export const menuApi = createApi({
  reducerPath: 'menuApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getMenuHome: builder.query({
      query: (restaurant_name) => ({
        url: 'api/web/v1/site/home',
        method: 'GET',
        params: {
          restaurant_name: restaurant_name,
        },
        withToken: false,
      }),
    }),

    getProductById: builder.query({
      query: (productId) => {
        const formData = new FormData();
        formData.append("product_id", productId);

        return {
          url: `api/web/v1/site/product-view?access-token=${ACCESS_TOKEN}`,
          method: "POST",
          data: formData,     
          isFormData: true,   
          withToken: false,
        };
      },
    }),

    // New contact endpoint
    submitContactForm: builder.mutation({
      query: (contactData) => {
        const formData = new FormData();
        formData.append("restaurant_id", contactData.restaurant_id);
        formData.append("name", contactData.name);
        formData.append("email", contactData.email);
        formData.append("mobile", contactData.mobile);
        formData.append("message", contactData.message);

        return {
          url: `api/web/v1/site/contact?access-token=${ACCESS_TOKEN}`,
          method: "POST",
          data: formData,
          isFormData: true,
          withToken: false,
        };
      },
    }),
  }),
});

export const { useGetMenuHomeQuery, useGetProductByIdQuery, useSubmitContactFormMutation } = menuApi;